class AgendaFilter {
  constructor() {
    this.filterBox = document.querySelector('.filter-box');
    this.filterLabel = document.querySelector('.filter-label');
    this.categoryButtons = document.querySelectorAll('.filter-for-categoria .filter-btn');
    this.sortSelect = document.getElementById('sort-order');
    this.yearSelect = document.getElementById('filter-year');
    this.activeFiltersList = document.getElementById('active-filters-list');
    this.clearAllFiltersBtn = document.getElementById('clear-all-filters');
    this.selectedCategories = new Set();
    this.sortOrder = '';
    this.selectedYear = '';


    
    this.categoryLabelByValue = new Map();

    this.init();
  }

  init() {
    this.categoryButtons.forEach((btn) => {
      const value = btn.getAttribute('data-filter-category');
      const label = (btn.textContent || '').trim();
      if (value) this.categoryLabelByValue.set(value, label);
    });

    if (this.filterLabel) {
      this.filterLabel.addEventListener('click', (e) => this.toggleFilterBox(e));
    }

    this.categoryButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => this.toggleCategory(e));
    });

    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', (e) => this.handleSortChange(e));
    }

    if (this.yearSelect) {
      this.yearSelect.addEventListener('change', (e) => this.handleYearChange(e));
    }

    if (this.clearAllFiltersBtn) {
      this.clearAllFiltersBtn.addEventListener('click', (e) => this.clearAllFilters(e));
    }

    // Carregar filtros da URL se existirem
    this.loadFiltersFromURL();
    this.updateActiveFiltersDisplay();
    
    // Disparar evento de filtro se houver filtros carregados da URL
    if (this.selectedCategories.size > 0 || this.selectedYear || this.sortOrder) {
      this.dispatchFilterEvent();
    }
  }

  toggleFilterBox(e) {
    e.preventDefault();
    this.filterBox.classList.toggle('active');
  }

  toggleCategory(e) {
    const btn = e.target;
    const category = btn.getAttribute('data-filter-category');

    if (this.selectedCategories.has(category)) {
      this.selectedCategories.delete(category);
      btn.classList.remove('active');
    } else {
      this.selectedCategories.add(category);
      btn.classList.add('active');
    }

    this.updateURL();
    this.updateActiveFiltersDisplay();
    this.dispatchFilterEvent();
  }

  handleSortChange(e) {
    this.sortOrder = e.target.value;
    this.updateURL();
    this.updateActiveFiltersDisplay();
    this.dispatchFilterEvent();
  }

  handleYearChange(e) {
    this.selectedYear = e.target.value;
    this.updateURL();
    this.updateActiveFiltersDisplay();
    this.dispatchFilterEvent();
  }

  removeFilter(type, value) {
    if (type === 'categoria') {
      this.selectedCategories.delete(value);
      const btn = document.querySelector(
        `.filter-for-categoria .filter-btn[data-filter-category="${value}"]`
      );
      if (btn) {
        btn.classList.remove('active');
      }
    } else if (type === 'ano') {
      this.selectedYear = '';
      if (this.yearSelect) {
        this.yearSelect.value = '';
      }
    } else if (type === 'sort') {
      this.sortOrder = '';
      if (this.sortSelect) {
        this.sortSelect.value = '';
      }
    }

    this.updateURL();
    this.updateActiveFiltersDisplay();
    this.dispatchFilterEvent();
  }

  clearAllFilters(e) {
    e.preventDefault();
    
    this.selectedCategories.clear();
    this.sortOrder = '';
    this.selectedYear = '';

    this.categoryButtons.forEach((btn) => {
      btn.classList.remove('active');
    });

    if (this.sortSelect) {
      this.sortSelect.value = '';
    }

    if (this.yearSelect) {
      this.yearSelect.value = '';
    }

    this.updateURL();
    this.updateActiveFiltersDisplay();
    this.dispatchFilterEvent();
  }

  updateActiveFiltersDisplay() {
    if (!this.activeFiltersList) return;

    this.activeFiltersList.innerHTML = '';

    // Adicionar categorias ativas
    this.selectedCategories.forEach((categoria) => {
      const tag = document.createElement('span');
      tag.className = 'active-filter-tag';
      const label = this.categoryLabelByValue.get(categoria) || categoria;
      tag.innerHTML = `
        ${label}
        <span class="remove-filter" data-type="categoria" data-value="${categoria}">×</span>
      `;
      
      const removeBtn = tag.querySelector('.remove-filter');
      removeBtn.addEventListener('click', () => {
        this.removeFilter('categoria', categoria);
      });

      this.activeFiltersList.appendChild(tag);
    });

    // Adicionar ano ativo
    if (this.selectedYear) {
      const tag = document.createElement('span');
      tag.className = 'active-filter-tag';
      tag.innerHTML = `
        ${this.selectedYear}
        <span class="remove-filter" data-type="ano">×</span>
      `;
      
      const removeBtn = tag.querySelector('.remove-filter');
      removeBtn.addEventListener('click', () => {
        this.removeFilter('ano');
      });

      this.activeFiltersList.appendChild(tag);
    }

    // Adicionar ordenação ativa
    if (this.sortOrder) {
      const sortLabel = this.sortOrder === 'asc' ? 'A > Z' : 'Z &lt; A';
      const tag = document.createElement('span');
      tag.className = 'active-filter-tag';
      tag.innerHTML = `
        ${sortLabel}
        <span class="remove-filter" data-type="sort">×</span>
      `;
      
      const removeBtn = tag.querySelector('.remove-filter');
      removeBtn.addEventListener('click', () => {
        this.removeFilter('sort');
      });

      this.activeFiltersList.appendChild(tag);
    }

    // Mostrar/esconder botão de limpar
    const hasActiveFilters = this.selectedCategories.size > 0 || this.selectedYear || this.sortOrder;
    if (this.clearAllFiltersBtn) {
      this.clearAllFiltersBtn.style.display = hasActiveFilters ? 'inline-block' : 'none';
    }
  }

  dispatchFilterEvent() {
    const event = new CustomEvent('agenda-filter-change', {
      detail: {
        categories: Array.from(this.selectedCategories),
        sortOrder: this.sortOrder,
        year: this.selectedYear
      }
    });
    document.dispatchEvent(event);
  }

  updateURL() {
    const params = new URLSearchParams(window.location.search);
    
    if (this.selectedCategories.size > 0) {
      params.set('categoria', Array.from(this.selectedCategories).join(','));
    } else {
      params.delete('categoria');
    }

    if (this.sortOrder) {
      params.set('sort', this.sortOrder);
    } else {
      params.delete('sort');
    }

    if (this.selectedYear) {
      params.set('ano', this.selectedYear);
    } else {
      params.delete('ano');
    }

    const newURL = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState({}, '', newURL);
  }

  loadFiltersFromURL() {
    const params = new URLSearchParams(window.location.search);
    
    // Carregar categorias
    const categoriesParam = params.get('categoria');
    if (categoriesParam) {
      const categories = categoriesParam.split(',');
      categories.forEach((category) => {
        const btn = document.querySelector(
          `.filter-for-categoria .filter-btn[data-filter-category="${category}"]`
        );
        if (btn) {
          this.selectedCategories.add(category);
          btn.classList.add('active');
        }
      });
    }

    // Carregar ordenação
    const sortParam = params.get('sort');
    if (sortParam && this.sortSelect) {
      this.sortSelect.value = sortParam;
      this.sortOrder = sortParam;
    }

    // Carregar ano
    const yearParam = params.get('ano');
    if (yearParam && this.yearSelect) {
      this.yearSelect.value = yearParam;
      this.selectedYear = yearParam;
    }
  }
}

// Inicializar quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new AgendaFilter();
  });
} else {
  new AgendaFilter();
}
